import React from 'react';
import { useRsi } from '../hooks/useRsi';
import { Box, styled } from '@beeline.com/bp-design-system';
import { DataGrid, DataGridProps } from '../ReactDataGrid';

interface Props<Data> extends DataGridProps<Data> {
  rowHeight?: number;
  hiddenHeader?: boolean;
  editable?: boolean;
}

export const Table = <Data,>({ className, editable, ...props }: Props<Data>) => {
  const { rtl } = useRsi();

  return (
    <StyledBox position="relative" $editable={editable}>
      <StyledDataGrid
        rowHeight={48}
        className={'rdg-light ' + className || ''}
        direction={rtl ? 'rtl' : 'ltr'}
        {...props}
      />
    </StyledBox>
  );
};

const StyledDataGrid = styled(DataGrid)`
    height: 100%;
` as typeof DataGrid;

const StyledBox = styled(Box)<{ $editable?: boolean }>`
    height: calc(100% - 4px); // Prevent double scrollbars.
    .rdg {
        border: none;

        input {
            background: transparent;
        }
        
        & [role="columnheader"] {
            background-color: #fff;
            font-weight: 500;
            z-index: 101; // Required to keep header above switch components.
        }
        
        ${({ $editable, theme }) =>
          $editable
            ? `
          & [role="gridcell"]:not(.rdg-checkbox) {
              cursor: text;
              &:hover {
                  box-shadow: inset 0 0 0 2px ${theme.tokens.source.colorPrimary};
              }
          }
         
        `
            : undefined}
        
        & [role="columnheader"], & [role="gridcell"] {
            box-shadow: none;
            border-inline: none;
        }
        
        & [role="gridcell"], & [role="columnheader"]:not(:empty) {
            padding: 12px;
            line-height: 22px;
        }
        
        & .rdg-cell-error {
            background-color: ${({ theme }) => theme.tokens.source.colorAlertContainer};
        }

        & .rdg-cell-warning {
            background-color: ${({ theme }) => theme.tokens.source.colorWarningContainer};
        }

        & .rdg-cell.rdg-editor-container {
            box-shadow: inset 0 0 0 2px ${({ theme }) => theme.tokens.source.colorPrimary} !important;
        }
            
        & [role="row"][aria-selected=true]{
            background-color: ${({ theme }) => theme.tokens.source.colorSecondaryContainer};
        }
    }
`;
